import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import View from 'react-flexbox'
import { Typography } from '@material-ui/core';


const grid = 2;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : 'grey',

    // styles we need to apply on draggables
    borderStyle: 'solid',
    backgroundColor: '#deedea',
    borderRadius: 8,
    borderWidth: 2,
    borderColor: '#16756f',
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'lightblue' : 'none',
    padding: grid,
    width: 250,
    minHeight: 250
});

class KambanTeste extends Component {

    componentWillMount() {
        // this.props.listar("EIJXpKfbkvkwzj1xDBTO")

    }


    onDragEnd = result => {
        const { source, destination } = result;

        // dropped outside the list
        if (!destination) {
            return;
        }

        if (source.droppableId === destination.droppableId) {
            let newArray = this.props.listaItens.slice();
            let listaAlterar = this.getItens(source.droppableId, newArray);
            let alterar = this.getItens(source.droppableId, newArray)[source.index];
            this.getItens(source.droppableId, newArray).slice(source.index + 1).forEach(element => {
                element[this.props.propOrdem] = element[this.props.propOrdem] + 1
            })

            const [removed] = listaAlterar.splice(source.index, 1);
            listaAlterar.splice(destination.index, 0, removed);

            listaAlterar.forEach((item, index) => {
                item[this.props.propOrdem] = index
            })


            this.props.updateLista(newArray)
        } else {

            let newArray = this.props.listaItens.slice();
            let listaAlterar = this.getItens(destination.droppableId, newArray);
            let alterar = this.getItens(source.droppableId, newArray)[source.index];
            if (alterar) {
                alterar[this.props.propOrdem] = destination.index
                alterar[this.props.propTipo] = destination.droppableId

                listaAlterar.splice(destination.index, 0, alterar);

                listaAlterar.forEach((item, index) => {
                    item[this.props.propOrdem] = index
                })
                this.props.updateLista(newArray)
            }
        }
    };
    getItens(tipo, array) {
        let itens = []
        let listFiltrar = this.props.listaItens
        if (array) {
            listFiltrar = array
        }

        if (tipo === ".") {
            itens = listFiltrar.filter(item => !item[this.props.propTipo])
        } else {
            itens = listFiltrar.filter(item => item[this.props.propTipo] === tipo)

        }
        let desimpate = () => 0;

        if (this.props.propOrdemAux) {
            desimpate = (a, b) => (a[this.props.propOrdemAux] > b[this.props.propOrdemAux]) ? 1 : ((b[this.props.propOrdemAux] > a[this.props.propOrdemAux]) ? -1 : 0)
        }

        itens = itens.sort((a, b) => (a[this.props.propOrdem] > b[this.props.propOrdem]) ? 1 : ((b[this.props.propOrdem] > a[this.props.propOrdem]) ? -1 : desimpate(a, b)));



        return itens
    }

    renderTipo(tipo) {

        let itens = this.getItens(tipo)
        return <div key={tipo} style={{ margin: 3 }}>
            <Typography>{tipo === "." ? "Caixa de Entrada" : tipo}</Typography>

            <Droppable droppableId={tipo}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}>
                        {itens.map((item, index) => (
                            <Draggable
                                key={"item"+item.uid}
                                draggableId={item.uid}
                                index={index}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                        )}>
                                        {/* {item.nome} */}
                                        {this.props.renderItem(item, getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                        ),tipo)}
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    }

    // Normally you would want to split things out into separate components.
    // But in this example everything is just done in one place for simplicity
    render() {
        const { listaTipos } = this.props;
        return (
            <View style={ {width: 1}}>

            <DragDropContext onDragEnd={this.onDragEnd}>
                <View>
                    {listaTipos && listaTipos.map(tip => this.renderTipo(tip))}
                </View>
            </DragDropContext>
            </View>
        );
    }
}

export default KambanTeste;



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/FluxoKamban/components/KambamComponent/index.js